
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
  addLoadPlanPackingRemark, exportHenganPlanDetail,
  getDetailForSeller,
} from "@/api/hengan-loading-plan";
import { downloadHqPackingList } from "@/api/hq-packing-list";
import { Message, Table } from "element-ui";
import { downloadFiles } from "@/utils/oss-download";
import { cloneDeep, sortedUniq } from "lodash";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { timeParser } from "@/filters";
import { stringify } from "querystring";
import {Decimal} from "decimal.js";

@Component({
  name: "HenganLoadingPlanDetail",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private henganLoadingPlanId: string;
  private hqPackingListDetailData: HqPackingListDetailResponse =
    new HqPackingListDetailResponse(null, null, null, null, null, null);
  private currentRow: HqPackingListTableRowData =
    new HqPackingListTableRowData();
  private planProductQuantity = 0;
  private planVolume = new Decimal(0);
  private planCartonQuantity = 0;
  private planPalletQuantity = 0;
  private planGrossWeight = new Decimal(0);
  private planNetWeight = new Decimal(0);

  created() {
    this.henganLoadingPlanId = this.$route.params.id;
    this.getList();
  }

  private async getList() {
    const {
      id,
      code,
      customerCode,
      customerAbbreviation,
      createdAt,
      packingLists,
      pcNames
    }: any = await getDetailForSeller(this.henganLoadingPlanId);
    this.hqPackingListDetailData = new HqPackingListDetailResponse(
      id,
      code,
      customerCode,
      customerAbbreviation,
      createdAt,
      pcNames
    );
    this.hqPackingListDetailData.hqPackingListTableData = packingLists
      .map((value) => {
        return value.productInfos.map((p, index) => {
          const row = new HqPackingListTableRowData();
          row.productRows = index === 0 ? value.productInfos.length : 0;
          row.id = value.id;
          row.code = value.code;
          row.factoryName = value.factoryName;
          row.outboundState = value.state;
          row.outboundTimes = value.outOfStorageTimes;
          row.description = p.description;
          row.declarationDescription = p.declarationDescription;
          row.outboundProductQuantity = p.outOfStorageQuantity;
          row.inStorageProductQuantity = p.inStorageQuantity;
          row.inStorageTotalVolume = p.inStorageTotalVolume;
          row.inStorageTotalGrossWeight = p.inStorageTotalGrossWeight;
          row.ctnQuantity = p.ctnQuantity;
          row.pltQuantity = p.pltQuantity;
          row.purchaserName = value.purchaserName;
          row.deliveryNoteCode = value.deliveryNoteCode;
          row.deliveryNoteId = value.deliveryNoteId;
          row.storageLayerNames = value.storageLayerNames;
          row.remark = value.remark;
          row.customsPackingRemainingQuantity =
            value.customsPackingRemainingQuantity;
          row.customsPackingTotalQuantity = value.customsPackingTotalQuantity;
          row.grossWeightOfAlreadyLoading = value.grossWeightOfAlreadyLoading;
          row.volumeOfAlreadyLoading = value.volumeOfAlreadyLoading;
          row.pltQuantityOfAlreadyLoading = value.pltQuantityOfAlreadyLoading;
          row.ctnQuantityOfAlreadyLoading = value.ctnQuantityOfAlreadyLoading;
          row.netWeightOfAlreadyLoading = value.netWeightOfAlreadyLoading;
          row.amountOfAlreadyLoading = value.amountOfAlreadyLoading;
          row.purchaseOrderNumberOfAlreadyLoading =
            value.purchaseOrderNumberOfAlreadyLoading;
          row.deduction = value.deduction;
          row.makeUpPayment = value.makeUpPayment;
          this.planProductQuantity = this.planProductQuantity + row.outboundProductQuantity;
          return row;
        });
      })
      .reduce((pre, cur) => pre.concat(cur), []);
    this.calculateTotal(packingLists);
    this.selectedHqPackingListIds = [];
    this.$nextTick(() => {
      const table = this.$refs.table as Table;
      if (table) {
        table.clearSelection();
      }
    });
  }

  private addRemarkDialogVisible = false;
  private showAddRemarkDialog(row: HqPackingListTableRowData) {
    this.currentRow = cloneDeep(row);
    this.addRemarkDialogVisible = true;
  }

  private showCustomsPackingStatistics(row: HqPackingListTableRowData) {
    if (row.customsPackingRemainingQuantity === undefined) {
      return "-";
    }
    return (
      row.customsPackingRemainingQuantity +
      "/" +
      row.customsPackingTotalQuantity
    );
  }

  private async doAddRemark() {
    const data: any = {
      hqPackingListId: this.currentRow.id,
      loadingPlanPackingRemark: this.currentRow.remark,
    };
    await addLoadPlanPackingRemark(this.henganLoadingPlanId, data);
    this.addRemarkDialogVisible = false;
    await this.getList();
  }

  // 导出excel
  private async exportExcel() {
  await exportHenganPlanDetail(this.henganLoadingPlanId)
  }

  private mergeIndex(title: String, begin: number, end: number) {
    return title + (begin + 3).toString() + ":" + title + (end + 3).toString();
  }

  private addToMerge(merges: String[], begin: number, end: number) {
    for (var i = 1; i < this.hqPackingListInfoColumns.length - 1; i++) {
      const codeIndex = this.hqPackingListInfoColumns[i];
      const char = String.fromCharCode(codeIndex + 64);
      merges.push(this.mergeIndex(char, begin, end));
    }
  }

  private arraySpanMethod({ row, columnIndex }) {
    if (this.isMergeColumn(columnIndex)) {
      if (row.productRows > 0) {
        return [row.productRows, 1];
      } else {
        return [0, 0];
      }
    }
  }

  private checkHqPackingListDetail(
    deliveryNoteId: string,
    hqPackingListId: string
  ) {
    this.$router.push({
      name: "HqPackingListDetail",
      params: {
        type: "delivery-note",
        parentId: deliveryNoteId,
        hqPackingListId: hqPackingListId,
      },
    });
  }

  private selectedHqPackingListIds: string[] = [];
  private hqPackingListInfoColumns: number[] = [
    0, 1, 2, 3, 4, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ];

  private isMergeColumn(columnIndex: number): boolean {
    return this.hqPackingListInfoColumns.includes(columnIndex);
  }

  private isRowSelectable(row: HqPackingListTableRowData): boolean {
    return row.productRows > 0;
  }

  private onSelectionChange(rows: HqPackingListTableRowData[]) {
    const ids = new Set<string>();
    rows.forEach((value) => {
      if (value && value.id) {
        ids.add(value.id);
      }
    });
    this.selectedHqPackingListIds = Array.from(ids);
  }

  private async downloadOriginalHqPackingListExcel() {
    if (this.selectedHqPackingListIds.length < 1) {
      Message.error({
        message: "请选择装箱单",
        duration: 2000,
      });
      return;
    }
    if (this.selectedHqPackingListIds.length > 30) {
      Message.error({
        message: "选择的装箱单过多，一次最多下载30条",
        duration: 2000,
      });
      return;
    }
    const res: any = await downloadHqPackingList({
      hqPackingListIds: this.selectedHqPackingListIds,
    });
    downloadFiles(res);
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }
  private calculateTotal(hqPackingListTableData:any[]) {
    hqPackingListTableData.forEach((row) => {
       this.planVolume = new Decimal(this.planVolume).plus( new Decimal(row.volumeOfAlreadyLoading));
       this.planCartonQuantity = this.planCartonQuantity + row.ctnQuantityOfAlreadyLoading;
       this.planPalletQuantity = this.planPalletQuantity + row.pltQuantityOfAlreadyLoading;
       this.planGrossWeight = new Decimal(this.planGrossWeight).plus( new Decimal(row.grossWeightOfAlreadyLoading));
       this.planNetWeight = new Decimal(this.planNetWeight).plus( new Decimal(row.netWeightOfAlreadyLoading));
    })
  }
}

class HqPackingListDetailResponse {
  id: string;
  code: string;
  customerCode: string;
  customerAbbreviation: string;
  createdAt: Date;
  pcNames: string;
  hqPackingListTableData: HqPackingListTableRowData[] = [];

  constructor(
    id: string,
    code: string,
    customerCode: string,
    customerAbbreviation: string,
    createdAt: Date,
    pcNames: string
  ) {
    this.id = id;
    this.code = code;
    this.customerCode = customerCode;
    this.customerAbbreviation = customerAbbreviation;
    this.createdAt = createdAt;
    this.pcNames = pcNames;
  }
}

class HqPackingListTableRowData {
  id: string;
  code: string;
  factoryName: string;
  outboundState: string;
  outboundTimes: number;
  description: string;
  declarationDescription: string;
  outboundProductQuantity: number;
  inStorageProductQuantity: number;
  inStorageTotalVolume: string;
  inStorageTotalGrossWeight: string;
  ctnQuantity: number;
  pltQuantity: number;
  purchaserName: string;
  deliveryNoteCode: string;
  deliveryNoteId: string;
  storageLayerNames: string;
  productRows: number;
  remark: string;
  customsPackingRemainingQuantity: number;
  customsPackingTotalQuantity: number;
  volumeOfAlreadyLoading: number;
  grossWeightOfAlreadyLoading: number;
  ctnQuantityOfAlreadyLoading: number;
  pltQuantityOfAlreadyLoading: number;
  purchaseOrderNumberOfAlreadyLoading: string[]; // 已经出库的产品，关联的采购订单号.
  amountOfAlreadyLoading: number; // 出库金额.
  netWeightOfAlreadyLoading: number; // 出库净重.
  deduction: number; // 扣款
  makeUpPayment: number; // 补款
}
